import { render, staticRenderFns } from "./DoctorPatientPaymentBillListForPatient.vue?vue&type=template&id=00892b6a&scoped=true"
import script from "./DoctorPatientPaymentBillListForPatient.vue?vue&type=script&lang=js"
export * from "./DoctorPatientPaymentBillListForPatient.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientPaymentBillListForPatient.vue?vue&type=style&index=0&id=00892b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00892b6a",
  null
  
)

export default component.exports